module.exports = "<!-- This page content will be blurred/frosted when foreground loader is showed -->\n<div ngxUiLoaderBlurred blur=\"10\">\n</div>\n<ngx-ui-loader></ngx-ui-loader>\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n<modal-outlet></modal-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main